import styled from 'styled-components';
import { xsRegular } from '../theme/typography';
import { themeColor } from '../theme/colors';

export const LeftSection = styled.div`
  ${xsRegular};
  color: ${themeColor('gray')};
  display: flex;
  min-width: 2ch;
`;
